// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"8c02b6a2","297":"43252f85","643":"9acd1df4","787":"4ad804cd"}[chunkId] + ".chunk.js";
};